export default {
	data: {
		language: 'en-US',/*
		defaultYarnCount: 'nm',
		defaultYarnType: 'needles-head',*/
		units: [
			{name: 'rpm', decimals: 0},
			{name: 'twists', decimals: 0},
			{name: 'mtmin', decimals: 3},
			{name: 'mt', decimals: 3},
			{name: 'kgh', decimals: 3}
		]
	}
}